// Shared CSV export — used by every list page's "Export" action (Purchase,
// Inventory, Memos, Sales). No new dependency: a CSV file is just a Blob
// download, and printing (window.print(), see the @media print rules in
// index.css) already covers the "PDF" need via the browser's own
// print-to-PDF, so a real PDF-generation library was never needed here.

function csvEscape(value: unknown): string {
  const s = value == null ? '' : String(value);
  // Only quote when the value actually needs it — a field containing a
  // comma, a quote, or a newline must be wrapped and have its own quotes
  // doubled, per the CSV spec; anything else is left bare for readability.
  if (/[",\n\r]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

export function downloadCSV(filename: string, headers: string[], rows: (string | number)[][]) {
  const lines = [headers, ...rows].map(row => row.map(csvEscape).join(','));
  // Leading BOM so Excel (Windows especially) opens ₹/€/etc. as UTF-8
  // instead of guessing a legacy codepage and mangling the currency symbol.
  const csv = '﻿' + lines.join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
